import { useVendorContext } from "@/contexts/vendor-context";
import Link from "next/link";
import { AnchorHTMLAttributes, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  passHref?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement> &
  PropsWithChildren;

const VendorLink = ({
  href,
  children,
  title,
  className,
  passHref,
  ...rest
}: Props) => {
  const { selectedVendor } = useVendorContext();

  const processedHref =
    href &&
    selectedVendor &&
    !href.startsWith(`/${selectedVendor}`) &&
    !href.startsWith(`/v/${selectedVendor}`)
      ? `/${selectedVendor}${href}`
      : href || "";

  if (!processedHref)
    return (
      <span className={className} title={title}>
        {children}
      </span>
    );

  return (
    <Link
      className={twMerge("group/vendor-link", className)}
      href={processedHref}
      passHref={passHref}
      title={title}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default VendorLink;
